import { render, staticRenderFns } from "./avatarUploader.vue?vue&type=template&id=05e8a0c1&"
import script from "./avatarUploader.vue?vue&type=script&lang=js&"
export * from "./avatarUploader.vue?vue&type=script&lang=js&"
import style0 from "./avatarUploader.vue?vue&type=style&index=0&id=05e8a0c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports